module.exports = __webpack_public_path__ + "static/media/favicon.f7e1e3e5.ico";